import React from "react";
import CajaVacia from "./CajaVacia";
import FormularioContacto from "./FormularioContacto";
import CajaGenerica from "./CajaGenerica";

export default function AcercaDe() {
    return (
        <div className="contenedor-principal">
            <section id={"acerca-de"}>
                <CajaVacia
                    encabezado={"Quienes somos?"}
                    titulo={"Un equipo que pedalea con Vos"}
                    descripcion={
                        "Somos un equipo que combina experiencia, cuidado y pasión por el ciclismo."
                    }
                    boton={""}
                />
                <div className="contenedor-imagenes"></div>

            </section>

            <section id={"placeres-en-catamarca"} className={"turismo-cerca"}>
                <CajaGenerica style={{background: "#1b1924"}}
                              icon={"cinco-estrellas"}
                              titulo={"Julieta"}
                              texto={"Pedalista reconocida, apasionada por enseñar y acompañar a mujeres ciclistas. Su rol es guiar, aconsejar y generar confianza en cada rodada."}
                />
            </section>
            <section id={"alojamientos-en-fiambala"} className={"turismo-cerca"}>
                <CajaGenerica
                    icon={"cinco-estrellas"}
                    titulo={"Tomás"}
                    texto={"Encargado de la logística y seguridad. Te recibe cada día, prepara todo lo necesario y acompaña en la camioneta para que no tengas que preocuparte por nada."}
                />
            </section>

        </div>
    );
}